var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"biz-week-plan-box"}},[_c('div',{staticClass:"chart-title"},[_c('img',{staticClass:"charts-icon",attrs:{"src":require('@/assets/images/largescreen/charts-icon.png'),"alt":""}}),_c('dv-decoration-1'),_c('span',[_vm._v("周预装机跟进管理")])],1),_c('dv-scroll-board',{attrs:{"id":"biz-week-table","config":_vm.config}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }